module.exports = DDC.WsmCommonData;


//////////////////
// WEBPACK FOOTER
// external "DDC.WsmCommonData"
// module id = 27
// module chunks = 0